import axios from './axios';

export const fetchWallet = async ({ cursor, limit = 50 } = {}) => {
    try {
        const params = { limit };
        if (cursor) params.cursor = cursor;
        const response = await axios.get('/wallet/get', { params });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.error || error.message);
    }
};
